import React, { useState, useRef, useEffect } from "react";
import { Box } from "@mui/material";
import Popper from "@mui/material/Popper";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useDarkMode } from "../context/darkModeContext";
import "./calendarPicker.css";

const CalendarPicker = ({
  selectedDate,
  setSelectedDate,
  enableCalendar = false,
  maxDate = new Date(),
}) => {
  const { colors } = useDarkMode();

  const [showCalendar, setShowCalendar] = useState(false);
  const anchorRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        !anchorRef.current?.contains(event.target) &&
        event.target.name !== "date-field"
      ) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const displayText = selectedDate
    ? selectedDate instanceof Date
      ? selectedDate.toLocaleDateString("en-US")
      : new Date(selectedDate).toLocaleDateString("en-US")
    : "Select Date";

  if (!enableCalendar) return null;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: `1px solid ${colors.border}`,
          px: 1.5,
          py: 0.5,
          background: colors.bgPaper,
          fontSize: 14,
          color: colors.textPrimary,
          gap: 1,
          cursor: "pointer",
        }}
        ref={anchorRef}
        onClick={() => setShowCalendar((prev) => !prev)}
      >
        <CalendarMonthOutlinedIcon
          sx={{ fontSize: 18, color: colors.textTertiary }}
        />
        <span style={{ fontSize: 12, color: colors.textSecondary }}>
          {displayText}
        </span>
      </Box>

      <Popper
        open={showCalendar}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        disablePortal
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 4],
            },
          },
        ]}
        sx={{ zIndex: 20000 }}
      >
        <Box
          ref={containerRef}
          sx={{
            bgcolor: colors.bgPaper,
            boxShadow: 3,
            borderRadius: 1,
            p: 1,
            zIndex: 20000,
            width: 300,
            "& .react-calendar": {
              width: "100%",
            },
          }}
        >
          <Calendar
            value={selectedDate ? new Date(selectedDate) : new Date()}
            onChange={(e) => {
              setShowCalendar(false);
              if (setSelectedDate) setSelectedDate(e);
            }}
            maxDate={maxDate}
            className="custom-calendar"
            defaultActiveStartDate={selectedDate ?? new Date()}
          />
        </Box>
      </Popper>
    </>
  );
};

export default CalendarPicker;
